import React from "react";
import { Calendar, Clock, Eye } from "lucide-react";
import { MatchDetails, MatchSetupConfig } from "../../models/match";
import { CourseConfig } from "../../models/teeBox";
import { formatDate, showTimeWithColon } from "../../utils/dateUtils";

interface MatchCardProps {
  match: MatchDetails;
  setupConfig: MatchSetupConfig;
  courseConfig: CourseConfig | null;
  onViewFlights: (match: MatchDetails, setupConfig: MatchSetupConfig) => void;
}

export const MatchCard: React.FC<MatchCardProps> = ({
  match,
  onViewFlights,
  setupConfig,
}) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden ${
        setupConfig.matchInProgress
          ? "ring-2 ring-green-500"
          : !setupConfig.isMatchCompleted && !setupConfig.matchInProgress
          ? "ring-2 ring-[#1a4731]"
          : ""
      }`}
    >
      {/* Header */}
      <div className="p-4 bg-[#1a4731] text-white">
        <div className="flex justify-between items-start">
          <div>
            <span className="px-2 py-1 bg-white/20 rounded-md text-sm">
              {match.groupOrKnockout}
            </span>
            <h3 className="text-lg font-semibold">{match.location}</h3>
          </div>
          <div className="text-right">
            <div className="flex items-center text-sm text-green-100">
              <Calendar className="w-4 h-4 mr-1" />
              {formatDate(match.date)}
            </div>
            <div className="flex items-center text-sm text-green-100 mt-1">
              <Clock className="w-4 h-4 mr-1" />
              {setupConfig.time && showTimeWithColon(setupConfig.time)}
            </div>
          </div>
        </div>
      </div>

      {/* Match Details */}
      <div className="p-4">
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Format
            </h4>
            <p className="text-gray-900 dark:text-white">
              {setupConfig.gameFormat} - {setupConfig.playFormat}
            </p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Teams
            </h4>
            <p className="text-gray-900 dark:text-white">
              {setupConfig.teamCount} Teams
            </p>
          </div>
        </div>

        <button
          onClick={() => onViewFlights(match, setupConfig)}
          className="w-full mt-4 bg-green-50 hover:bg-green-100 dark:bg-[#1a4731]/20 dark:hover:bg-[#1a4731]/30 text-[#1a4731] dark:text-green-400 py-2 px-4 rounded-lg font-medium flex items-center justify-center transition-colors"
        >
          <Eye className="w-4 h-4 mr-2" />
          View Flight Details
        </button>
        
      </div>
    </div>
  );
};
